import React from 'react';
import { Link } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import PropTypes from 'prop-types';
import { LedgerEntryType } from '../../common/Helpers';

const NFTokenPage = (props) => {
	const { node } = props;
    if ( node?.LedgerEntryType === LedgerEntryType.NFTokenPage ) {
        return (
            <>
                {node?.PreviousPageMin &&
                <tr>
                    <td>PreviousPageMin:</td>
                    <td>
                        <span>
                            <Link to={`/object/${node.PreviousPageMin}`}>{node.PreviousPageMin}</Link>
                        </span>
                    </td>
                </tr>
                }
                {node?.NextPageMin &&
                <tr>
                    <td>NextPageMin:</td>
                    <td>
                        <span>
                            <Link to={`/object/${node.NextPageMin}`}>{node.NextPageMin}</Link>
                        </span>
                    </td>
                </tr>
                }

                {node?.NFTokens &&
                <tr>
                    <td>NFTokens:</td>
                    <td>
                        <Table responsibe>
                           <thead>
                               <tr>
                                    <th>#</th>
                                    <th>NFTokenID</th>
                                </tr>
                            </thead>
                            <tbody>
                                {node.NFTokens.map((NFToken, index) => {
                                    return(
                                        <tr>
                                            <td>{index + 1}</td>
                                            <td>
                                                <span className='hash'>
                                                    <Link to={`/nft/${NFToken?.NFToken?.NFTokenID}`}>{NFToken?.NFToken?.NFTokenID}</Link>
                                                </span>
                                            </td>
                                        </tr>
                                    )
                                    })
                                }
                            </tbody>
                        </Table>
                    </td>
                </tr>
                }                
            </>
        );    
    } else {
        return <></>;
    }
}

NFTokenPage.propTypes = {
	node: PropTypes.object,
}

export default NFTokenPage;